import { z } from 'zod';
// v2 agent MCP tool-observation contract (KIR-4910). When the Go agent sees an
// MCP tool call in a PreToolUse hook it reports the (server, tool) pair here so
// the backend can ADD the tool to that server's inventory row. This is how the
// org learns the tools of servers the agent cannot list itself (e.g. every
// server behind an auth-gated MCP gateway). Mirrors the Go types in
// extensions/agent/pkg/mcp/hook_tools.go -- JSON keys must match exactly.
//
// Identity (user/org) comes from the API key; machine + source come from the
// same Kirin-Machine-Id / Kirin-Client-Type headers a scan carries, so a tool
// only ever lands on the reporting endpoint's own inventory rows.
// Postgres jsonb rejects U+0000 and unpaired UTF-16 surrogates, so either would
// fail the write with a 500. Reject them up front as a 400.
const LONE_SURROGATE = /[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/;
const storableText = (max) => z
    .string()
    .max(max)
    .refine(s => !s.includes('\u0000') && !LONE_SURROGATE.test(s), {
    message: 'must not contain NUL or unpaired surrogates',
});
export const mcpToolObservationSchema = z.object({
    // MCP server name as the AI client names it in the tool call (Claude Code
    // sanitizes it to [A-Za-z0-9_-]); matched to the inventory config key.
    server: storableText(256).pipe(z.string().min(1)),
    tool: storableText(256).pipe(z.string().min(1)),
    // Present only where the platform exposes one (Claude Code transcripts).
    description: storableText(4096).optional(),
    // The AI client's working directory for the call: picks the project's
    // server when several config files declare a server with the same name.
    cwd: storableText(4096).optional(),
});
export const mcpToolObservationsRequestSchema = z.object({
    observations: z.array(mcpToolObservationSchema).min(1).max(50),
});
export const mcpToolObservationsResponseSchema = z.object({
    // Inventory rows the observations were merged into. 0 means no inventory
    // row matched (server not inventoried yet for this machine/source) -- the
    // agent may retry on a later call.
    matchedRows: z.number().int().nonnegative(),
});
//# sourceMappingURL=mcp-tool-observations.js.map